import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useKeycloak } from "../utils/KeycloakProvider";

const useAxiosInstance = (): AxiosInstance => {
  const keycloak = useKeycloak();

  const axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
      "Content-Type": "application/json",
    },
  });


  axiosInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
      if (keycloak) {
        try {
          await keycloak.updateToken(5);
          config.headers.Authorization = `Bearer ${keycloak.token}`;
        } catch (err) {
          console.error("Failed to refresh token", err);
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse): AxiosResponse => {
      return response;
    },
    (error: AxiosError) => {
      console.error("API error:", error.response?.data || error.message);

      if (error.response?.status === 403) {
        console.warn("Unauthorized - Redirecting to login...");
        // Add your redirect or logout logic
      }

      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default useAxiosInstance;
